import { render, staticRenderFns } from "./downloadList.vue?vue&type=template&id=11446ce0&scoped=true"
import script from "./downloadList.vue?vue&type=script&lang=js"
export * from "./downloadList.vue?vue&type=script&lang=js"
import style0 from "./downloadList.vue?vue&type=style&index=0&id=11446ce0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11446ce0",
  null
  
)

export default component.exports